// LLM generated - Model GPT-5.5
import axios from 'axios';

import RequestHeadersBase from '~/common/constants/RequestHeadersBase';

import { handleRefreshInterceptor } from '../interceptors/handle-refresh.interceptor';
import { setAuthTokenInterceptor } from '../interceptors/set-auth-token.interceptor';

export const locationServiceInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL_PAYMENTS_SERVICE}`,
  headers: {
    ...RequestHeadersBase,
  },
});

setAuthTokenInterceptor(locationServiceInstance);
handleRefreshInterceptor(locationServiceInstance);
